import { useCallback } from 'react';

/**
 * Returns a callback which invokes onCommit if the given
 * currentValue is different from the given initialValue.
 * If using this with an onBlur event, wrap it around with useOnBlurUpdate.
 */
export function useCommitIfValueChanged<T>(
    initialValue: T,
    currentValue: T,
    onCommit: (newValue: T) => void
) {
    return useCallback(
        function commitIfValueChanged() {
            if (currentValue != initialValue) {
                onCommit(currentValue);
            }
        },
        [initialValue, currentValue, onCommit]
    );
}
